import * as signalR from "@microsoft/signalr";
import { setDoctorJoined, store } from "utils/redux-store";
import WebClient, { constants } from "./webclient";

class IKhcHub {

    constructor(intl) {
        this.connection = null
        this.intl = intl
    }

    Start() {

        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(`${constants.baseURL}/khcHub`)
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (retryContext) => {
                    if (retryContext.elapsedMilliseconds < 20000) {
                        return Math.random() * 5000;
                    } else {
                        console.error('It takes more than 20 seconds to reconnect the socket.');
                        // setNetworkError(true);
                        return 5000;
                    }
                },
            })
            .configureLogging(signalR.LogLevel.Debug)
            .build();

        this.connection.start().then((a) => {
            console.log("Socket Connected", a)
            this.LoginKhcHub()
        }).catch((error) => {

        });

        this.connection.onreconnecting(() => {
            console.log("Reconnecting!...")
            // setIsGlobalLoading(true);
        });

        this.connection.onreconnected(() => {
            console.log("Reconnected!...")
            this.LoginKhcHub()
        })
    }

    Disconnect() {
        this.connection?.stop()
    }

    On(method, callback = () => { }, error = () => { }) {

        if (this.connection?.state == signalR.HubConnectionState.Connected) {
            this.connection.on(method, callback)
        } else {
            error("Socket is not connected!")
        }

    }

    LoginKhcHub = async () => {
        if (this.connection?.state == signalR.HubConnectionState.Connected) {

            console.log("LoginKhcHub", this.connection.connectionId)

            const _state = store.getState()

            await new WebClient().post('5B3C6EB831DD570F8A84/LoginKhcHub', {
                connectionId: this.connection.connectionId,
                requesterType: 1,
                requester: {
                    id: _state.member.profileId,
                    fullName: _state.patient.fullName,
                    userName: "P-" + _state.member.profileId
                }
            });

            this.connection.on("StartPatientAppointmentCallNotLoby", (message) => {
                setDoctorJoined(message)
            })

        }
    }

}

export default IKhcHub